import React, { useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
  Button, Label, Input,
} from '../../../ui'
import { formatMoney } from '../../../../utils/helpers'

// Quitar una beca no es un "¿seguro?": hay dinero otorgado, y parte puede estar ya
// aplicado a cargos. Se muestran los numeros y se deja elegir que hacer con lo
// aplicado, porque esa es una decision del club y no del sistema.
const QuitarBecaDialog = ({ open, onOpenChange, beca, jugador, onConfirm }) => {
  const [cobrar, setCobrar] = useState(false)
  const [fecha, setFecha] = useState(() => new Date().toISOString().slice(0, 10))
  const [saving, setSaving] = useState(false)

  if (!beca) return null
  const hayAplicado = beca.aplicado > 0

  const confirmar = async () => {
    setSaving(true)
    try {
      await onConfirm({ cobrarAplicado: hayAplicado && cobrar, fechaVencimiento: fecha })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !saving) onOpenChange(false) }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Quitar beca</DialogTitle></DialogHeader>

        <div className="space-y-4">
          <div className="rounded-lg border bg-muted/30 p-3 text-sm">
            <p className="font-medium">{beca.nombre}</p>
            <p className="text-xs text-muted-foreground">{jugador}</p>
            <dl className="mt-2 space-y-1 text-xs">
              <div className="flex justify-between"><dt>Otorgado</dt><dd className="tabular-nums">{formatMoney(beca.otorgado)}</dd></div>
              <div className="flex justify-between"><dt>Ya aplicado a cargos</dt><dd className="tabular-nums">{formatMoney(beca.aplicado)}</dd></div>
              <div className="flex justify-between font-medium"><dt>Disponible sin usar</dt><dd className="tabular-nums">{formatMoney(beca.disponible)}</dd></div>
            </dl>
          </div>

          <p className="text-sm text-muted-foreground">
            Se retiran los {formatMoney(beca.disponible)} que no se han usado.
            {hayAplicado && ' Lo ya aplicado no se revierte: esos cargos siguen saldados.'}
          </p>

          {hayAplicado && (
            <div className="space-y-2 rounded-lg border p-3">
              <label className="flex items-start gap-2 text-sm">
                <input
                  type="checkbox"
                  className="mt-0.5 h-4 w-4 rounded border-input"
                  checked={cobrar}
                  onChange={(e) => setCobrar(e.target.checked)}
                />
                <span>
                  <span className="font-medium">Cobrar también lo ya aplicado</span>
                  <span className="block text-xs text-muted-foreground">
                    Genera un cargo de {formatMoney(beca.aplicado)} con la nota “Cancelación de beca”.
                    Los cargos originales no se tocan.
                  </span>
                </span>
              </label>
              {cobrar && (
                <div className="space-y-1 pl-6">
                  <Label className="text-xs">Vence el</Label>
                  <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                </div>
              )}
            </div>
          )}

          {cobrar && (
            <p className="flex items-start gap-2 rounded-md bg-amber-50 p-2 text-xs text-amber-900">
              <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              El jugador quedará debiendo {formatMoney(beca.aplicado)} más de lo que debe hoy.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Cancelar</Button>
          <Button onClick={confirmar} disabled={saving}>
            {saving ? 'Quitando...' : 'Quitar beca'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default QuitarBecaDialog
